module.exports = __webpack_public_path__ + "static/author-4-437674505fa61c11dd940f15b61f956f.jpg";